import { Fragment, useContext, useEffect, useState } from "react";
import { BacktoMyAccount } from "../backToMyAccount";
import { isValidArray } from "../../../Layout/Common/common";
import { CardIcon } from "../../../Layout/Common/CardIcon";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { GlobalContext } from "../../../Context/GlobalContext";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { showErrorSnackbar, showSuccessSnackbar } from "../../../utils/snackbarNotifications";

export const MyWalletCardList = ({ data }) => {
  const [cardList, setcardList] = useState(null);
  const { updateDefaultCard, removeStoreCard } = useGlobalFunction();
  const { showDialogAlert, hideNoteAlert, showNoteAlert, showFlashScreen } = useNoteAlert();
  useEffect(() => {
    setcardList(data);
  }, [data]);

  const handleDeleteClick = (uuid) => {
    showDialogAlert({
      content: "Do you want to delete this card permanently?",
      title: "Delete Confirmation",
      primaryBtn: { caption: "Yes, Remove", onClick: () => deleteRemove(uuid) },
      scondaryBtn: { caption: "Cancel", onClick: hideNoteAlert },
    });
  };

  const deleteRemove = async (uuid) => {
    try {
      hideNoteAlert();
      var response = await removeStoreCard(uuid);
      if (!response) {
        showErrorSnackbar("Something went wrong. Please try again.");
      } else {
        showSuccessSnackbar("Card Removed Successfully.");
      }
    } catch (error) {
      showErrorSnackbar("Something went wrong. Please try again.");
      hideNoteAlert();
    }
  };
  return (
    <Fragment>
      {isValidArray(cardList) && (
        <TransitionGroup className={"row"}>
          <Fragment>
            {cardList.map((row, index) => (
              <Fragment>
                {row.isdefault && (
                  <div className="col-lg-12 mt-3">
                    <p className="default-wallet">Default:</p>
                  </div>
                )}
                <CSSTransition key={index} timeout={500} classNames="card">
                  <div className="col-sm-6 col-md-4 mt-3" key={index}>
                    <div className={`my-wallet ${row.isdefault ? "active" : ""}`}>
                      <div className="walletSection">
                        <div className="walletSection-lft">
                          <CardIcon cardType={row.cardType || row.card_type} />

                          <div className="walletSection-details">
                            <h4>{row.cardName}</h4>
                            <p>xxxx xxxx xxxx x{row.cardNo}</p>
                            <div className={`wallet-exp ${row.IsExpired ? "expired-text" : ""}`}>
                              Expiry {row.cardExp}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="myWallet-selection">
                        <p
                          className="text-decoration-underline d-block"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDeleteClick(row.cardUuid)}
                        >
                          Remove
                        </p>
                        {row.isdefault ? (
                          <p> Default </p>
                        ) : (
                          <p
                            onClick={() => {
                              updateDefaultCard(row.cardUuid);
                            }}
                          >
                            Set as Default
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </CSSTransition>
              </Fragment>
            ))}
          </Fragment>
        </TransitionGroup>
      )}
    </Fragment>
  );
};
